import { ComponentNameEnum, StepperSignEnum, BaseStepperFieldConfig } from '@/types';

const getStepperFieldConfig = (sign = StepperSignEnum.NONE, step = 1, min?: number, max?: number): BaseStepperFieldConfig => ({
  componentName: ComponentNameEnum.STEPPER,
  options: {
    sign,
    step,
    ...(min !== undefined && { min }),
    ...(max !== undefined && { max }),
  },
});

export default getStepperFieldConfig;
